export default "__VITE_ASSET__BtmY0iFq__"